import { IoPause, IoPlay } from "react-icons/io5";
// import { IChapter } from "../../../types/book";
import * as S from "./chapter.style";
import { BsClockFill, BsCloudDownloadFill } from "react-icons/bs";
import { useAudio } from "../../audiobook/audio/context/audio-context";
import { useBookContext } from "../../../context/book/book-context";
import Waves from "../../waves/waves";
import Loading from "../../loading/loading";
import React from "react";

export const Chapter = ({ chapter }) => {
  const {
    isPlaying,
    handlePlayPause,
    audioRef,
    progressChaptersGroup,
  } = useAudio();

  const { currentChapter, setCurrentChapter, loadingChunk } = useBookContext();
  const isActiveChapter = currentChapter.title === chapter.title;
  const currentChapterPlaying = isPlaying && isActiveChapter;

  const isLoadingPartialChunkDownload = isActiveChapter && loadingChunk;

  const onClickChapterPlay = () => {
    if (!audioRef.current) return;

    setCurrentChapter(chapter);
    if (!isActiveChapter) {
      audioRef.current.currentTime = 0;
      audioRef.current.src = chapter.audioUrl;

      setTimeout(() => {
        handlePlayPause(true);
      }, 1000);

      return;
    }
    handlePlayPause();
  };

  const progress = progressChaptersGroup[chapter.uid || ""] || 0;

  const formatTime = (time) => {
    if (!time) return "00:00";
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);
    return `${hours > 0 ? `${hours}:` : ""}${
      hours > 0 && minutes < 10 ? `0${minutes}` : minutes
    }:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  return (
    <S.Wrapper>
      <S.ChapterContainer>
        <S.Flex>
          <S.ControllPlayContainer isPlaying={currentChapterPlaying}>
            <S.WaveContainer>
              {isLoadingPartialChunkDownload ? <Loading /> : <Waves />}
            </S.WaveContainer>
            <S.ControlButtonPlay onClick={onClickChapterPlay}>
              {currentChapterPlaying ? (
                <IoPause size={20} />
              ) : (
                <IoPlay size={20} />
              )}
            </S.ControlButtonPlay>
          </S.ControllPlayContainer>

          <S.ChapterInfo>
            <S.ChapterTitle>
              {chapter.title}
            </S.ChapterTitle>
            <S.ChapterTime>
              <BsClockFill /> {formatTime(chapter.duration)}
            </S.ChapterTime>
          </S.ChapterInfo>
        </S.Flex>

        <S.ChapterDownload>
          <BsCloudDownloadFill size={20} />
        </S.ChapterDownload>
      </S.ChapterContainer>

      <S.ChapterProgress progress={progress}>
        <span />
      </S.ChapterProgress>
    </S.Wrapper>
  );
};
